import { setContext } from '@apollo/client/link/context'
import { from, type GraphQLRequest } from '@apollo/client/link/core'

export default defineNuxtPlugin(() => {
  const { public: config } = useRuntimeConfig()

  if (config.recaptchaSiteKey) {
    const { initialize, executeRecaptcha, recaptchaLoaded } = useReCaptcha()

    const recaptchaLink = setContext(async (operation: GraphQLRequest) => {
      if (config.recaptchaOperations?.includes(operation.operationName || '')) {
        await initialize()
        await recaptchaLoaded()

        const token = await executeRecaptcha(operation.operationName)

        return {
          headers: {
            'x-recaptcha': token,
          },
        }
      }

      return {}
    })

    const { client } = useApolloClient('customer')
    client.setLink(from([
      recaptchaLink,
      client.link,
    ]))
  }
})
